import Navbar from "../components/Navbar";
import Footer from "../components/Footer";
import ExpertiseData from "../components/ExpertiseData";

function Expertise() {
  return (
    <>
      <Navbar />
      {/* <Background /> */}
      {/* <HomeHero
        cName="hero-mid"
        heroImg={AboutImg}
        title="About"
        btnClass="hide"
      /> */}
      <ExpertiseData />
      <Footer />
    </>
  );
}

export default Expertise;
